// Берет только домен, без остального пути
export const getDomainFromUrl = (urlString) => {
  if (typeof urlString !== 'string' || !urlString.trim()) {
    return null;
  }
  
  let urlToParse = urlString.trim();
  if (urlToParse.startsWith('//')) {
    urlToParse = 'https:' + urlToParse;
  } else if (!/^[a-zA-Z][a-zA-Z0-9+.-]*:\/\//.test(urlToParse)) {
    urlToParse = 'https://' + urlToParse;
  }
  
  try {
    const parsedUrl = new URL(urlToParse);
    return parsedUrl.hostname;
  } catch (error) {
    console.error(`Not parse URL: "${urlString}". Error: ${error.message}`);
    let fallback = urlString.replace(/^[a-zA-Z][a-zA-Z0-9+.-]*:\/\//i, '');
    fallback = fallback.split('/')[0];
    fallback = fallback.split(':')[0];
    fallback = fallback.split('?')[0];
    fallback = fallback.split('#')[0];
    if (fallback && fallback.includes('.') && !fallback.includes(' ')) {
      return fallback;
    }
    
    return null;
  }
}
